import { Platform } from "react-native";

/** True on phone/tablet runtimes — not browser. */
export const isNativeTouch = Platform.OS === "android" || Platform.OS === "ios";

/**
 * Touch-friendly sizing for Android/iOS; compact for web.
 * Material / Apple HIG recommend ~48dp minimum targets on phones.
 */
export const touchUI = {
  minHit: isNativeTouch ? 48 : 36,
  topBarMin: isNativeTouch ? 56 : 48,
  backMinWidth: isNativeTouch ? 108 : 72,
  backPadH: isNativeTouch ? 12 : 8,
  backPadV: isNativeTouch ? 10 : 6,
  backChevron: isNativeTouch ? 40 : 30,
  backLabel: isNativeTouch ? 18 : 15,
  title: isNativeTouch ? 18 : 17,
  hitSlop: isNativeTouch ? 12 : 8,
  primaryPadV: isNativeTouch ? 16 : 12,
  primaryFont: isNativeTouch ? 16 : 14,
  chipPadH: isNativeTouch ? 14 : 12,
  chipPadV: isNativeTouch ? 10 : 8,
};
